export default __webpack_public_path__ + "static/media/accenture.701a21cb.svg";